// src/modules/app-views/goodsReceipt/pages/Init/components/tableColumns/statusColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const STATUS_COLORS = {
  draft: 'default',
  confirmed: 'success',
  cancelled: 'error',
};

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function statusColumn(buildColumnProps, options = {}) {
  return {
    title: translateX('status'),
    dataIndex: 'status',
    ...buildColumnProps('status', {
      sort: true,
      filter: true,
      filterOptions: ['draft', 'confirmed', 'cancelled'],
    }),
    width: 120,
    align: 'center',
    render: (_, record) => {
      const status = record?.status;
      if (!status) return '—';
      const color = STATUS_COLORS[status] || 'default';
      return <Tag color={color}>{translateX(status)}</Tag>;
    },
  };
}

export default statusColumn;
